import { create } from 'zustand';

import { VOTER_EMAIL_PAGE_SIZE } from './emails';

interface VoterEmailsQueryState {
  search: string;
  page: number;
  pageSize: number;
  setSearch: (search: string) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<VoterEmailsQueryState, 'search' | 'page' | 'pageSize'> = {
  search: '',
  page: 1,
  pageSize: VOTER_EMAIL_PAGE_SIZE,
};

export const useVoterEmailsStore = create<VoterEmailsQueryState>((set) => ({
  ...defaults,

  setSearch: (search) => set({ search, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
